import React from 'react'

import NavBar from './components/navbar'
import HeroSection from './components/hero_section';
import AboutUsSection from './components/aboutus_section';
import FeaturesSection from './components/features_section';
import Section_1 from './components/section_1';
import Section_2 from './components/section_2';
import Section_3 from './components/section_3';
import CtaJoinSection from './components/calltoaction';
import Footer from './components/footer';

const Main = () => {

    return (
        <div className=''>
            <NavBar />
            <HeroSection />
            <AboutUsSection />
            <FeaturesSection />
            <br></br>
            <Section_1 />
            <Section_2 />
            <Section_3 />
            <CtaJoinSection />
            <br></br>
            <Footer />
        </div>
    )
}

export default Main
